(function () {
  'use strict';

  angular.module('dashboard.project.alltime', ['ngResource']);
})();
